import { useState } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { RemoveItemFromPlaylistButton, useSavedItemsTooltip, useShowNavbarPlaylistsTooltip, useShowNavbarWatchLaterTooltip, useTimedLatestSavedItemsInteraction } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { theme, useMediaQuery, css } from 'academy-common-lib/utils/Styling';
import { ArchivePlaylistButton, SavePlaylistButton, getMyPlaylistsUrl } from '../../myPlaylists';
import { UnAssignPlaylistButton, getAssignmentsForPortalUrl } from '../../playlistAssignments';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const tooltipButtonStyles = props => css(["border-color:", " !important;", " text-decoration:none !important;&&:hover{text-decoration:none;", "}"], theme.colors.OLAF, props.use === 'primary' && css(["background-color:", " !important;color:", " !important;"], theme.colors.OLAF, theme.colors.HEFFALUMP), props.use === 'primary' ? css(["background-color:", " !important;color:", " !important;"], theme.colors.OLAF, theme.colors.HEFFALUMP) : props.use === 'tertiary' && css(["color:", " !important;background-color:none !important;"], theme.colors.OLAF));
const TooltipActionButton = styled(UIButton).withConfig({
  displayName: "NavbarSavedItemsTooltip__TooltipActionButton",
  componentId: "sc-1azepsv-0"
})(["", ""], props => tooltipButtonStyles(props));
const TooltipRouterButton = styled(UIRouterButton).withConfig({
  displayName: "NavbarSavedItemsTooltip__TooltipRouterButton",
  componentId: "sc-1azepsv-1"
})(["", ""], props => tooltipButtonStyles(props));
export const SavePlaylistTooltipText = () => {
  const {
    action,
    playlistName,
    playlistId
  } = useSavedItemsTooltip();
  const {
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: action === 'SAVE_PLAYLIST' ? 'learningCenter.savedItems.tooltips.savedPlaylist' : 'learningCenter.savedItems.tooltips.unsavedPlaylist',
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "p-top-3",
      gap: 6,
      children: [/*#__PURE__*/_jsx(TooltipRouterButton, {
        size: "small",
        to: getMyPlaylistsUrl({
          tab: 'saved'
        }),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isNotMobile ? 'learningCenter.savedItems.tooltips.viewSavedPlaylists' : 'learningCenter.savedItems.tooltips.viewMobile'
        })
      }), action === 'SAVE_PLAYLIST' && /*#__PURE__*/_jsx(SavePlaylistButton, {
        className: isNotMobile ? undefined : 'm-left-2',
        playlistId: playlistId,
        render: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.savedItems.tooltips.undo'
        }),
        use: "link-on-dark"
      })]
    })]
  });
};
const ArchivePlaylistTooltipText = () => {
  const {
    action,
    playlistName,
    playlistId
  } = useSavedItemsTooltip();
  const {
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: action === 'ARCHIVE_PLAYLIST' ? 'learningCenter.savedItems.tooltips.archivedPlaylist' : 'learningCenter.savedItems.tooltips.unarchivedPlaylist',
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "p-top-3",
      gap: 6,
      children: [/*#__PURE__*/_jsx(TooltipRouterButton, {
        size: "small",
        to: getMyPlaylistsUrl({
          tab: action === 'ARCHIVE_PLAYLIST' ? 'archived' : undefined
        }),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: action === 'ARCHIVE_PLAYLIST' ? isNotMobile ? 'learningCenter.savedItems.tooltips.viewArchivedPlaylists' : 'learningCenter.savedItems.tooltips.viewMobile' : 'learningCenter.savedItems.tooltips.viewMyPlaylists'
        })
      }), action === 'ARCHIVE_PLAYLIST' && /*#__PURE__*/_jsx(ArchivePlaylistButton, {
        className: isNotMobile ? undefined : 'm-left-2',
        playlistId: playlistId,
        render: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.savedItems.tooltips.undo'
        }),
        use: "link-on-dark"
      })]
    })]
  });
};
const AddToPlaylistsTooltipText = () => {
  const {
    itemName,
    itemType,
    itemId,
    action,
    playlistName,
    playlistId
  } = useSavedItemsTooltip();
  const {
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: action === 'ADD_TO_PLAYLIST' ? 'learningCenter.savedItems.tooltips.savedToPlaylist' : playlistName ? 'learningCenter.savedItems.tooltips.removedFromPlaylist' : 'learningCenter.savedItems.tooltips.removedFromGenericPlaylist',
      options: {
        itemName,
        playlistName
      }
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "p-top-3",
      gap: 6,
      children: [/*#__PURE__*/_jsx(TooltipRouterButton, {
        size: "small",
        to: `/saved-items/playlists/${playlistId}`,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isNotMobile || action !== 'ADD_TO_PLAYLIST' ? 'learningCenter.savedItems.tooltips.viewPlaylist' : 'learningCenter.savedItems.tooltips.viewMobile'
        })
      }), action === 'ADD_TO_PLAYLIST' && /*#__PURE__*/_jsx(RemoveItemFromPlaylistButton, {
        className: isNotMobile ? undefined : 'm-left-2',
        itemId: itemId,
        itemType: itemType,
        playlistId: playlistId,
        use: "link-on-dark",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.savedItems.tooltips.undo'
        })
      })]
    })]
  });
};
const WatchLaterTooltipText = () => {
  const {
    itemName,
    action
  } = useSavedItemsTooltip();
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: action === 'ADD_TO_WATCH_LATER' ? 'learningCenter.savedItems.tooltips.savedToWatchLater' : 'learningCenter.savedItems.tooltips.removedFromWatchLater',
    options: {
      title: itemName
    }
  });
};
const DuplicatePlaylistTooltipText = () => {
  const {
    playlistId
  } = useSavedItemsTooltip();
  const {
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: 'learningCenter.savedItems.tooltips.duplicatedPlaylist'
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      className: "p-top-3",
      gap: 6,
      children: /*#__PURE__*/_jsx(TooltipRouterButton, {
        size: "small",
        to: `/saved-items/playlists/${playlistId}`,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isNotMobile ? 'learningCenter.savedItems.tooltips.viewPlaylist' : 'learningCenter.savedItems.tooltips.viewMobile'
        })
      })
    })]
  });
};
const CreatePlaylistAssignmentTooltipText = () => {
  const {
    playlistId,
    playlistName,
    portalId,
    assignmentIds,
    removeLatestInteraction
  } = useSavedItemsTooltip();
  if (!playlistId || !playlistName || !assignmentIds) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: 'learningCenter.savedItems.tooltips.assignmentsCreated',
      options: {
        count: 1,
        playlistName
      }
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "p-top-3",
      gap: 6,
      children: [/*#__PURE__*/_jsx(TooltipRouterButton, {
        onClick: removeLatestInteraction,
        size: "small",
        to: getAssignmentsForPortalUrl({
          playlistId,
          portalId: portalId,
          documentFragmentLink: true
        }),
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'learningCenter.savedItems.tooltips.viewProgress'
        })
      }), /*#__PURE__*/_jsx(UnAssignPlaylistButton, {
        assignments: assignmentIds,
        onDeleted: removeLatestInteraction,
        render: ({
          handleOnClick
        }) => /*#__PURE__*/_jsx(TooltipActionButton, {
          onClick: handleOnClick,
          size: "small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'learningCenter.common.undo'
          })
        })
      })]
    })]
  });
};
export const NavbarSavedItemsTooltipText = () => {
  const [isOverTooltip, setIsOverTooltip] = useState(false);
  const action = useTimedLatestSavedItemsInteraction(isOverTooltip);
  return action && /*#__PURE__*/_jsxs("div", {
    onMouseEnter: () => setIsOverTooltip(true),
    onMouseLeave: () => setIsOverTooltip(false),
    children: [['SAVE_PLAYLIST', 'UNSAVE_PLAYLIST'].includes(action) && /*#__PURE__*/_jsx(SavePlaylistTooltipText, {}), ['ARCHIVE_PLAYLIST', 'UNARCHIVE_PLAYLIST'].includes(action) && /*#__PURE__*/_jsx(ArchivePlaylistTooltipText, {}), ['ADD_TO_PLAYLIST', 'REMOVE_FROM_PLAYLIST'].includes(action) && /*#__PURE__*/_jsx(AddToPlaylistsTooltipText, {}), ['ADD_TO_WATCH_LATER', 'REMOVE_FROM_WATCH_LATER'].includes(action) && /*#__PURE__*/_jsx(WatchLaterTooltipText, {}), ['DUPLICATE_PLAYLIST'].includes(action) && /*#__PURE__*/_jsx(DuplicatePlaylistTooltipText, {}), ['CREATE_PLAYLIST_ASSIGNMENT'].includes(action) && /*#__PURE__*/_jsx(CreatePlaylistAssignmentTooltipText, {})]
  });
};
export const NavbarSavedItemsTooltip = ({
  children,
  type
}) => {
  const showNavbarWatchLaterTooltip = useShowNavbarWatchLaterTooltip();
  const showNavbarPlaylistsTooltip = useShowNavbarPlaylistsTooltip();
  let show;
  switch (type) {
    case 'PLAYLISTS':
      show = showNavbarPlaylistsTooltip;
      break;
    case 'WATCH_LATER':
      show = showNavbarWatchLaterTooltip;
      break;
    default:
      show = showNavbarWatchLaterTooltip || showNavbarPlaylistsTooltip;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    open: show,
    title: /*#__PURE__*/_jsx(NavbarSavedItemsTooltipText, {}),
    children: children
  });
};
export default NavbarSavedItemsTooltip;